import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'transformUrlToHref'
})

export class TransformUrlToHrefPipe implements PipeTransform {

  transform(value: any, args?: any): any {
    const urlRegex = /(((https?:\/\/)|(www\.))[^\s]+)/g;
    return value.replace(urlRegex, function(url) {
      return '<a href="' + url + '">' + url + '</a>';
    });
  }

}
